module.exports = __webpack_public_path__ + "static/media/female_old.c7e93040.svg";